module.exports = __webpack_public_path__ + "img/ic_vtc.2461c73f.png";